<section class="quotation">
    <div class="container">
        <div class="row align-items-md-center">
            <div class="order-2 order-lg-1 col-md-6">
                <h1 class="mb-3 quotation-title" [innerHTML]="'quotation-section/title' | translate"></h1>
                <p>
                    {{'quotation-section/description-one' | translate}}
                </p>
                <p class="mb-4 quotation-bold">
                    {{'quotation-section/description-two' | translate}}
                </p>
                <a routerLink="/contact-us"
                   class="btn btn-gradient quotation-button">
                    {{'quotation-section/request-quotation' | translate}}
                    <span class="ml-3 p-carousel-prev-icon pi pi-chevron-right"></span>
                </a>
            </div>
            <div class="order-1 order-lg-2 offset-md-1 col-md-4">
                <img src="assets/images/img-solicite-orcamento.png"
                     class="mb-4 mb-md-0  img-fluid"
                     alt="Solicite uma cotação"
                     title="Solicite uma cotação"
                     loading="lazy"
                     width="1060"
                     height="704">
            </div>
        </div>
    </div>
</section>
